export default __webpack_public_path__ + "static/media/Thailand.3422c30b.svg";